/* Bilingual content tree for Antiaging by BB.
   Used by HomePage and ProgramsPage. Add new languages/sections here. */

export const CONTENT = {
  en: {
    nav: { home: "Home", tirzepatide: "Tirzepatide", nadPlus: "NAD+", sermorelin: "Sermorelin", how: "How It Works", guides: "Free Guides", contact: "Contact", shop: "Shop" },

    hero: {
      eyebrow: "Medical Weight Loss · Miami",
      h1_pre: "Finally Lose Weight, Feel ", h1_em: "in Control", h1_post: " & Get Your Energy Back",
      sub: "Medically guided programs designed to fix your metabolism, control cravings, and deliver real, sustainable results.",
      cta: "Check Your Eligibility",
      trust: ["Medical supervision included", "Personalized protocol", "Fast approval", "Delivered to your door"],
    },
    stats: [
      { v: "20.9%", l: "Avg. Weight Loss — Tirzepatide" },
      { v: "50%",   l: "NAD+ Lost by Age 50" },
      { v: "24h",   l: "Provider Review Time" },
    ],
    ticker: ["Medical Weight Loss Miami","Tirzepatide","NAD+ Antiaging","Sermorelin Hormone Optimization","Physician Supervised","HIPAA Compliant","Delivered Nationwide","Miami FL · Biscayne Blvd"],

    problem: {
      eyebrow: "If This Sounds Like You…",
      h2_pre: "You're doing everything right… but your body ", h2_em: "isn't responding",
      bullets: ["You've tried diets.", "You've tried working out.", "You've tried staying consistent."],
      closing_pre: "And still… nothing works the way it should.",
      closing_mid: "It's not your discipline. It's not your effort.",
      closing_post: "It's your metabolism and hormones.",
    },

    solution: {
      eyebrow: "The Solution",
      h2_pre: "A Medical Approach That ", h2_em: "Actually Works",
      sub: "Most programs fail because they don't address how your body actually works. We do.",
      cards: [
        { t: "Regulate appetite",          d: "Reduce cravings at the source — neurologically, not by willpower." },
        { t: "Improve metabolic function", d: "Reset how your body processes food, fat, and energy." },
        { t: "Support real fat loss",      d: "Targeted protocols backed by clinical evidence." },
        { t: "Restore energy",             d: "Cellular-level support so you feel like yourself again." },
      ],
      closing: "This is not a diet. This is a structured medical solution.",
    },

    mainOffer: {
      eyebrow: "Our Most Popular Program",
      h2: "Tirzepatide",
      badge: "⭐ Most Popular",
      tagline: "Control your appetite. Reset your metabolism. Lose weight with structure.",
      pills: ["Reduce cravings","Support fat loss","Improve metabolism","Feel in control again"],
      cta: "Start My Program",
      guide: "Free Guide ↓",
    },

    support: {
      eyebrow: "Anti-Aging Support",
      h2_pre: "Beyond Weight Loss: Energy & ", h2_em: "Anti-Aging Support",
      sub: "Designed to complement your results — at the cellular and hormonal level.",
      nad: { eyebrow: "Cellular Anti-Aging", title: "NAD+",
             tagline: "Restore your energy, focus & mental clarity.",
             body: "A coenzyme that supports cellular energy production at the foundational level. Helps clear brain fog, sharpen focus, and reverse fatigue from within.",
             cta: "Add to my plan" },
      serm: { eyebrow: "Hormone Optimization", title: "Sermorelin",
              tagline: "Support recovery, sleep & natural anti-aging.",
              body: "Stimulates your pituitary to produce growth hormone naturally. Rebuilds lean muscle, firms skin, and dramatically improves deep sleep — month after month.",
              cta: "Optimize my plan" },
      closing: "These are designed to complement your results.",
    },

    why: {
      eyebrow: "Authority · Why It Works",
      h2_pre: "Why This Works When ", h2_em: "Nothing Else Has",
      sub: "Your body isn't broken. It's just not being supported correctly.",
      cards: [
        { title: "Hormones", desc: "Aligned signaling so your body responds to fuel, fasting, and rest the way it should." },
        { title: "Metabolism", desc: "Reset the engine that determines how efficiently you burn — not just how much you eat." },
        { title: "Appetite Regulation", desc: "Eliminate cravings at the brain level — not through forced restraint." }
      ],
      closing: "When those are aligned, your body responds.",
    },

    how: {
      eyebrow: "How It Works",
      h2_pre: "Simple. Clear. ", h2_em: "Guided.",
      sub: "Takes less than 2 minutes to start. Designed for your body.",
      steps: [
        { t: "Complete your online evaluation",  d: "Quick health intake — under 2 minutes." },
        { t: "Get reviewed by a licensed provider", d: "A real medical team — not an algorithm." },
        { t: "Receive your personalized plan",   d: "Designed for your body, not a generic protocol." },
        { t: "Start your transformation",        d: "Delivered to your door. Supported the whole way." },
      ],
      cta: "Get Started Now",
    },

    pricing: {
      eyebrow: "Pricing",
      h1_pre: "Starting at ",
      sub_strong: "Prices vary by state.", sub_post: " Select your state to view your pricing and available promotions.",
      cta: "Check My Price",
      micro: "*Personalized for your body",
    },

    trust: {
      eyebrow: "Trust",
      h2_pre: "A Medical Approach You ", h2_em: "Can Trust",
      pillars: ["Licensed providers","Telehealth compliant","Personalized protocols","Secure & confidential"],
    },

    finalCta: {
      h2_pre: "Ready to Take Control of Your ", h2_em: "Body Again?",
      sub: "This is your moment to stop guessing and start following a plan that actually works.",
      cta: "Get Started Now",
      micro: "Personalized for your body · You're almost done",
    },

    guides: {
      eyebrow: "Free Resources",
      h2_pre: "Download Your ", h2_em: "Free", h2_post: " Guides",
      sub: "Expert guides on every protocol — written by our clinical team. No sign-up required.",
      items: [
        { i: "⚖", t: "The Medical Weight Loss Guide" },
        { i: "⚡", t: "The NAD+ Antiaging Guide" },
        { i: "🌙", t: "The Antiaging Hormone Guide" },
      ],
      link: "Download Free Guide ↓",
    },

    reviews: {
      eyebrow: "Client Experiences",
      h2_pre: "Real Patients. ", h2_em: "Real Results.",
      tag: "Verified Google Review",
      items: [
        { name: "Carlitos J", text: "Outstanding service from start to finish. The team made the entire process seamless and I started seeing results in weeks." },
        { name: "Franco D'Rivera", text: "NAD+ has completely changed my energy levels and mental clarity. I feel like I'm in my 30s again." },
        { name: "Arknet B", text: "Professional staff, transparent pricing, and a real medical team. Best decision I've made this year." },
      ],
    },

    hipaa: { strong: "HIPAA Compliant", text: " — Your health information is protected under federal privacy law. We never share or sell your data." },

    footer: {
      tagline: "Medically guided weight loss & anti-aging. Miami's premier clinic for cellular renewal and metabolic transformation.",
      navH: "Navigation", navItems: ["Tirzepatide","NAD+ & Sermorelin","How It Works","Pricing","Free Guides"],
      gsH: "Get Started", gsItems: ["Shop Programs","Check Eligibility","Individual Products"],
      ctH: "Contact",
      hours: "Mon Tue Thu Fri · 9AM–5PM",
      copyright: "© 2026 Antiaging by BB · All rights reserved · HIPAA Compliant",
      privacy: "Privacy Policy", terms: "Terms of Service",
    },

    // Programs page
    pp: {
      heroEyebrow: "Guided Program Selection · Miami, FL · Nationwide Shipping",
      heroH1_pre: "Find the Right", heroH1_em: "Program for Your Body",
      heroSub: "Select your state to view personalized pricing and available programs.",
      heroTrust: ["Medical supervision included","Personalized protocols","Fast approval","Secure process"],
      step12: "Step 1 · Select Your State · Step 2 · Choose Your Program",
      protoTitle_pre: "Choose Your ", protoTitle_em: "Protocol",
      protoSub: "Each program is built around a different level of intensity and outcome. Continue to the intake form to confirm your state's pricing and available promotions.",
      startingAt: "Starting at",
      pricesVary: "Prices vary by state · Select your state to view pricing and promotions",
      eligTitle: "Not sure where to start?",
      eligSub: "We guide you based on your evaluation. Takes less than 2 minutes.",
      eligCta: "Check My Eligibility →",
      includesLabel: "Includes", bestForLabel: "Best for", resultsLabel: "Results",
      planMicro: "Medical supervision included · *Prices vary by state",
      addons: [
        { i: "💉", n: "Syringes (10-pack)*", d: "Add-on at checkout", p: "+ $10*" },
        { i: "🏷️", n: "Membership Savings",   d: "Min. 3-month commitment", p: "Save every month" },
      ],
      alacarteEyebrow: "À La Carte",
      alacarteTitle_pre: "Individual ", alacarteTitle_em: "Products",
      alacarteSub: "Purchase any product individually. Membership pricing available with a minimum 3-month commitment.",
      treatEyebrow: "In-Clinic · Miami, FL",
      treatTitle_pre: "20 Treatments.", treatTitle_em: "One Goal: Younger.",
      tabs: [{ id:"all", label:"All" }, { id:"injectables", label:"Injectables" }, { id:"lasers", label:"Lasers & Special" }, { id:"facials", label:"Facials" }, { id:"threads", label:"Threads" }, { id:"wellness", label:"Wellness" }],
      compareEyebrow: "Side By Side",
      compareTitle_pre: "Which Product is ", compareTitle_em: "Right For You?",
      bookCta: "Book →",
      whoLabel: "Who it's for:",
      howLabel: "How it works:",
      includedLabel_single: "What's included:",
      freeGuide: "Free Guide ↓",
      beforeLabel: "Before",
      afterLabel: "After",
      compTable: {
        feature: "Feature",
        tirzepatideHeader: "Tirzepatide",
        sermorelinHeader: "Sermorelin",
        primaryGoal: "Primary Goal",
        startingPrice: "Starting Price (mbr)",
        skinBenefits: "Skin Benefits",
        weightLoss: "Weight Loss",
        energy: "Energy",
        muscleBuilding: "Muscle Building",
        sleepQuality: "Sleep Quality",
        atHome: "At Home",
        prescriptionReq: "Prescription Required",
        // NAD+ column
        nadGoal: "Cellular energy & skin",
        nadPrice: "$297/mo",
        nadSkin: "★ Primary",
        nadWeight: "Metabolic support",
        nadEnergy: "★ Within days",
        nadMuscle: "Supports recovery",
        nadSleep: "Mild improvement",
        // Tirzepatide column
        tirzGoal: "Medical weight loss",
        tirzPrice: "From $397/mo*",
        tirzSkin: "Indirect",
        tirzWeight: "★ Up to 20.9%",
        tirzEnergy: "Moderate",
        tirzMuscle: "Preserves muscle",
        tirzSleep: "Moderate",
        // Sermorelin column
        sermGoal: "Hormone optimization",
        sermPrice: "From $297/mo",
        sermSkin: "★ Collagen boost",
        sermWeight: "Fat reduction",
        sermEnergy: "★ Month 1+",
        sermMuscle: "★ Primary",
        sermSleep: "★ Dramatic",
        // Common
        yes: "✔ Yes",
        supervised: "✔ Supervised",
        pricesVaryFootnote: "*Prices vary by state",
      },
    },
  },

  es: {
    nav: { home: "Inicio", tirzepatide: "Tirzepatida", nadPlus: "NAD+", sermorelin: "Sermorelina", how: "Cómo Funciona", guides: "Guías Gratuitas", contact: "Contacto", shop: "Tienda" },

    hero: {
      eyebrow: "Pérdida de Peso Médica · Miami",
      h1_pre: "Baja de peso, ", h1_em: "siente el control", h1_post: " y recupera tu energía",
      sub: "Programas médicos diseñados para arreglar tu metabolismo, controlar la ansiedad por la comida y entregar resultados reales y sostenibles.",
      cta: "Ver si califico",
      trust: ["Supervisión médica incluida","Protocolo personalizado","Aprobación rápida","Entregado a tu puerta"],
    },
    stats: [
      { v: "20.9%", l: "Pérdida de Peso Promedio — Tirzepatida" },
      { v: "50%",   l: "NAD+ Perdido a los 50" },
      { v: "24h",   l: "Tiempo de Revisión Médica" },
    ],
    ticker: ["Pérdida de Peso Médica Miami","Tirzepatida","NAD+ Anti-Edad","Optimización Hormonal Sermorelina","Supervisión Médica","Cumple HIPAA","Envío Nacional","Miami FL · Biscayne Blvd"],

    problem: {
      eyebrow: "Si Te Identificas…",
      h2_pre: "Estás haciendo todo bien… pero tu cuerpo ", h2_em: "no responde",
      bullets: ["Has probado dietas.","Has hecho ejercicio.","Has sido constante."],
      closing_pre: "Y aun así… nada funciona como debería.",
      closing_mid: "No es tu disciplina. No es tu esfuerzo.",
      closing_post: "Es tu metabolismo y tus hormonas.",
    },

    solution: {
      eyebrow: "La Solución",
      h2_pre: "Un Enfoque Médico Que ", h2_em: "Realmente Funciona",
      sub: "La mayoría de los programas fallan porque no abordan cómo funciona tu cuerpo. Nosotros sí.",
      cards: [
        { t: "Regula el apetito",         d: "Reduce los antojos en su origen — neurológicamente, no por fuerza de voluntad." },
        { t: "Mejora el metabolismo",     d: "Restablece cómo tu cuerpo procesa comida, grasa y energía." },
        { t: "Apoya pérdida real de grasa", d: "Protocolos respaldados por evidencia clínica." },
        { t: "Recupera tu energía",       d: "Apoyo a nivel celular para que vuelvas a sentirte tú." },
      ],
      closing: "Esto no es una dieta. Es una solución médica estructurada.",
    },

    mainOffer: {
      eyebrow: "Nuestro Programa Más Popular",
      h2: "Tirzepatida",
      badge: "⭐ Más Popular",
      tagline: "Controla tu apetito. Reinicia tu metabolismo. Pierde peso con estructura.",
      pills: ["Reduce antojos","Apoya pérdida de grasa","Mejora metabolismo","Recupera el control"],
      cta: "Quiero Empezar mi Plan",
      guide: "Guía Gratis ↓",
    },

    support: {
      eyebrow: "Soporte Anti-Edad",
      h2_pre: "Más Allá de la Pérdida de Peso: Energía & ", h2_em: "Soporte Anti-Edad",
      sub: "Diseñado para complementar tus resultados — a nivel celular y hormonal.",
      nad: { eyebrow: "Anti-Edad Celular", title: "NAD+",
             tagline: "Recupera tu energía, foco y claridad mental.",
             body: "Una coenzima que apoya la producción de energía celular en el nivel fundamental. Ayuda a despejar la niebla mental, agudizar el foco y revertir la fatiga desde adentro.",
             cta: "Agregar a mi plan" },
      serm: { eyebrow: "Optimización Hormonal", title: "Sermorelina",
              tagline: "Apoya la recuperación, el sueño y el anti-aging natural.",
              body: "Estimula tu pituitaria para producir hormona del crecimiento naturalmente. Reconstruye masa magra, firma la piel y mejora dramáticamente el sueño profundo — mes a mes.",
              cta: "Optimizar mi plan" },
      closing: "Diseñados para complementar tus resultados.",
    },

    why: {
      eyebrow: "Autoridad · Por Qué Funciona",
      h2_pre: "Por Qué Funciona Cuando ", h2_em: "Nada Más Lo Hizo",
      sub: "Tu cuerpo no está roto. Solo no está siendo apoyado correctamente.",
      cards: [
        { title: "Hormonas", desc: "Señalización alineada para que tu cuerpo responda al combustible, ayuno y descanso como debería." },
        { title: "Metabolismo", desc: "Reinicia el motor que determina qué tan eficientemente quemas — no solo cuánto comes." },
        { title: "Regulación del Apetito", desc: "Elimina los antojos a nivel cerebral — no a través de restricción forzada." }
      ],
      closing: "Cuando estos están alineados, tu cuerpo responde.",
    },

    how: {
      eyebrow: "Cómo Funciona",
      h2_pre: "Simple. Claro. ", h2_em: "Guiado.",
      sub: "Toma menos de 2 minutos comenzar. Diseñado para tu cuerpo.",
      steps: [
        { t: "Completa tu evaluación en línea",     d: "Cuestionario rápido — menos de 2 minutos." },
        { t: "Revisado por un médico licenciado",   d: "Un equipo médico real — no un algoritmo." },
        { t: "Recibe tu plan personalizado",        d: "Diseñado para tu cuerpo, no un protocolo genérico." },
        { t: "Comienza tu transformación",          d: "Entregado a tu puerta. Acompañado en todo el camino." },
      ],
      cta: "Comienza Ahora",
    },

    pricing: {
      eyebrow: "Precio",
      h1_pre: "Desde ",
      sub_strong: "Los precios varían por estado.", sub_post: " Selecciona tu estado para ver tu precio y promociones disponibles.",
      cta: "Ver Mi Precio",
      micro: "*Personalizado para tu cuerpo",
    },

    trust: {
      eyebrow: "Confianza",
      h2_pre: "Un Enfoque Médico En El Que ", h2_em: "Puedes Confiar",
      pillars: ["Médicos licenciados","Cumple telesalud","Protocolos personalizados","Seguro y confidencial"],
    },

    finalCta: {
      h2_pre: "¿Listo Para Tomar Control de Tu ", h2_em: "Cuerpo de Nuevo?",
      sub: "Este es tu momento de dejar de adivinar y seguir un plan que realmente funciona.",
      cta: "Comienza Ahora",
      micro: "Personalizado para tu cuerpo · Casi terminas",
    },

    guides: {
      eyebrow: "Recursos Gratuitos",
      h2_pre: "Descarga Tus Guías ", h2_em: "Gratuitas", h2_post: "",
      sub: "Guías expertas para cada protocolo — escritas por nuestro equipo clínico. Sin registro.",
      items: [
        { i: "⚖", t: "Guía Médica de Pérdida de Peso" },
        { i: "⚡", t: "Guía Anti-Edad NAD+" },
        { i: "🌙", t: "Guía Hormonal Anti-Edad" },
      ],
      link: "Descargar Guía Gratis ↓",
    },

    reviews: {
      eyebrow: "Experiencias de Clientes",
      h2_pre: "Pacientes Reales. ", h2_em: "Resultados Reales.",
      tag: "Reseña Verificada de Google",
      items: [
        { name: "Carlitos J", text: "Servicio excepcional de principio a fin. El equipo hizo todo el proceso fluido y comencé a ver resultados en semanas." },
        { name: "Franco D'Rivera", text: "El NAD+ ha cambiado completamente mis niveles de energía y claridad mental. Me siento como en mis 30s otra vez." },
        { name: "Arknet B", text: "Personal profesional, precios transparentes y un equipo médico real. La mejor decisión que he tomado este año." },
      ],
    },

    hipaa: { strong: "Cumple HIPAA", text: " — Tu información de salud está protegida bajo la ley federal de privacidad. Nunca compartimos ni vendemos tus datos." },

    footer: {
      tagline: "Pérdida de peso médica y anti-aging. La clínica premier de Miami para renovación celular y transformación metabólica.",
      navH: "Navegación", navItems: ["Tirzepatida","NAD+ & Sermorelina","Cómo Funciona","Precio","Guías Gratuitas"],
      gsH: "Comienza", gsItems: ["Comprar Programas","Verificar Elegibilidad","Productos Individuales"],
      ctH: "Contacto",
      hours: "Lun Mar Jue Vie · 9AM–5PM",
      copyright: "© 2026 Antiaging by BB · Todos los derechos reservados · Cumple HIPAA",
      privacy: "Política de Privacidad", terms: "Términos de Servicio",
    },

    pp: {
      heroEyebrow: "Selección Guiada de Programa · Miami, FL · Envío Nacional",
      heroH1_pre: "Encuentra el", heroH1_em: "Programa para Tu Cuerpo",
      heroSub: "Selecciona tu estado para ver precios y programas personalizados.",
      heroTrust: ["Supervisión médica incluida","Protocolos personalizados","Aprobación rápida","Proceso seguro"],
      step12: "Paso 1 · Selecciona Tu Estado · Paso 2 · Elige Tu Programa",
      protoTitle_pre: "Elige Tu ", protoTitle_em: "Protocolo",
      protoSub: "Cada programa está diseñado en un nivel diferente de intensidad y resultado. Continúa al formulario para confirmar el precio y promociones de tu estado.",
      startingAt: "Desde",
      pricesVary: "Los precios varían por estado · Selecciona tu estado para ver precio y promociones",
      eligTitle: "¿No estás seguro por dónde empezar?",
      eligSub: "Te guiamos según tu evaluación. Toma menos de 2 minutos.",
      eligCta: "Verificar Mi Elegibilidad →",
      includesLabel: "Incluye", bestForLabel: "Ideal para", resultsLabel: "Resultados",
      planMicro: "Supervisión médica incluida · *Los precios varían por estado",
      addons: [
        { i: "💉", n: "Jeringas (paquete de 10)*", d: "Adicional al pagar", p: "+ $10*" },
        { i: "🏷️", n: "Ahorro de Membresía",        d: "Min. 3 meses de compromiso", p: "Ahorra cada mes" },
      ],
      alacarteEyebrow: "A La Carta",
      alacarteTitle_pre: "Productos ", alacarteTitle_em: "Individuales",
      alacarteSub: "Compra cualquier producto individualmente. Precios de membresía disponibles con un compromiso mínimo de 3 meses.",
      treatEyebrow: "En Clínica · Miami, FL",
      treatTitle_pre: "20 Tratamientos.", treatTitle_em: "Una Meta: Más Joven.",
      tabs: [{ id:"all", label:"Todos" }, { id:"injectables", label:"Inyectables" }, { id:"lasers", label:"Láser & Especiales" }, { id:"facials", label:"Faciales" }, { id:"threads", label:"Hilos" }, { id:"wellness", label:"Bienestar" }],
      compareEyebrow: "Lado a Lado",
      compareTitle_pre: "¿Qué Producto es ", compareTitle_em: "Adecuado Para Ti?",
      bookCta: "Reservar →",
      whoLabel: "Para quién es:",
      howLabel: "Cómo funciona:",
      includedLabel_single: "Qué incluye:",
      freeGuide: "Guía Gratis ↓",
      beforeLabel: "Antes",
      afterLabel: "Después",
      compTable: {
        feature: "Característica",
        tirzepatideHeader: "Tirzepatida",
        sermorelinHeader: "Sermorelina",
        primaryGoal: "Objetivo Principal",
        startingPrice: "Precio Inicial (miembro)",
        skinBenefits: "Beneficios para la Piel",
        weightLoss: "Pérdida de Peso",
        energy: "Energía",
        muscleBuilding: "Construcción Muscular",
        sleepQuality: "Calidad del Sueño",
        atHome: "En Casa",
        prescriptionReq: "Requiere Receta",
        // NAD+ column
        nadGoal: "Energía celular y piel",
        nadPrice: "$297/mes",
        nadSkin: "★ Primario",
        nadWeight: "Apoyo metabólico",
        nadEnergy: "★ En días",
        nadMuscle: "Apoya recuperación",
        nadSleep: "Mejora leve",
        // Tirzepatide column
        tirzGoal: "Pérdida de peso médica",
        tirzPrice: "Desde $397/mes*",
        tirzSkin: "Indirecto",
        tirzWeight: "★ Hasta 20.9%",
        tirzEnergy: "Moderado",
        tirzMuscle: "Preserva músculo",
        tirzSleep: "Moderado",
        // Sermorelin column
        sermGoal: "Optimización hormonal",
        sermPrice: "Desde $297/mes",
        sermSkin: "★ Impulso de colágeno",
        sermWeight: "Reducción de grasa",
        sermEnergy: "★ Mes 1+",
        sermMuscle: "★ Primario",
        sermSleep: "★ Dramático",
        // Common
        yes: "✔ Sí",
        supervised: "✔ Supervisado",
        pricesVaryFootnote: "*Los precios varían por estado",
      },
    },
  },
};

export function getContent(lang) {
  return CONTENT[lang] || CONTENT.en;
}
